import React from 'react';

type ContextProps = {
  device: string | null;
};

const DeviceContext = React.createContext<ContextProps>({
  device: null,
});

function getMobileOperatingSystem(): string | null {
  var userAgent = navigator.userAgent || navigator.vendor || (window as any).opera;

  if (/windows phone/i.test(userAgent)) {
    return 'Windows Phone';
  }

  if (/android/i.test(userAgent)) {
    return 'Android';
  }

  if (/win/i.test(userAgent)) {
    return 'Windows';
  }

  if (/mac/i.test(userAgent)) {
    return 'Mac';
  }

  if (/linux/i.test(userAgent)) {
    return 'Mac';
  }

  // iOS detection from: http://stackoverflow.com/a/9039885/177710
  if (/iPad|iPhone|iPod/.test(userAgent) && !(window as any).MSStream) {
    return 'iOS';
  }

  return null;
}

function DeviceProvider(props: any) {
  const device = getMobileOperatingSystem();
  const value: ContextProps = React.useMemo(() => {
    return {
      device: device,
    };
  }, [device]);

  return <DeviceContext.Provider {...props} value={value} />;
}

function useDevice(): ContextProps {
  const context = React.useContext(DeviceContext);
  if (context === undefined) {
    throw new Error('Device must be used within an DeviceProvider');
  }
  return context;
}

export {DeviceContext, DeviceProvider, useDevice};
